import { render, staticRenderFns } from "./ChangeDisplayOrder.vue?vue&type=template&id=3617b01c&scoped=true&"
import script from "./ChangeDisplayOrder.vue?vue&type=script&lang=ts&"
export * from "./ChangeDisplayOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeDisplayOrder.vue?vue&type=style&index=0&id=3617b01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617b01c",
  null
  
)

export default component.exports